/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from "react";
import KeywordInputGroup from "./KeywordInputGroup";
import useProfile from "@/hooks/use-profile";
import { Roles } from "@/utilities/types/Users";
import KeywordRepository from "@/utilities/repositories/Keywords";
import { EKeywordType, IKeyword } from "@/utilities/types/Keyword";
import toast from "react-hot-toast";
import { validUrl } from "@/utilities/functions";

export interface Keyword {
  id: number;
  keyword: string;
  url: string;
}

const KeywordManager: React.FC = () => {
  const [initialData, setInitialData] = React.useState<IKeyword[]>([]);
  const { profile } = useProfile();

  const saveKeywords = async (data: IKeyword[]) => {
    const filteredData = data.filter(
      (item) => item.name?.trim() !== "" && item.value?.trim() !== ""
    );

    const newData = filteredData.map((item) => ({
      id: item.id,
      name: item.name,
      value: item.value,
      type: EKeywordType.TRENDING_PROJECTS, // currently only one type
    }));
    
    // Find deleted keywords: in initialData but not in data
    const seoKeywordDeleteIds: string[] = initialData
      .filter((item) => !data.some((d) => d.id === item.id))
      .map((item) => item.id)
      .filter(Boolean) as string[];

    try {
      await KeywordRepository.createOrUpdateKeywords({
        keywords: newData,
        seoKeywordDeleteIds,
      });
      toast.success("Keywords saved successfully");
    } catch (error) {
      toast.error("Failed to save keywords");
      console.error(error);
    }
  };

  const fetchKeywords = async () => {
    try {
      const res = await KeywordRepository.getKeywords();
      const keywordData = res?.data?.items || [];
      setInitialData(keywordData);
    } catch (error) {}
  };

  useEffect(() => {
    fetchKeywords();
  }, []);

  if (profile?.role !== Roles.ADMIN) return <></>;

  return (
    <div className="p-4 bg-white rounded-lg shadow-sm">
      <h2 className="text-xl font-semibold mb-4">SEO Keywords</h2>
      <KeywordInputGroup onSave={saveKeywords} initialData={initialData} refetch={fetchKeywords}/>
    </div>
  );
};

export default KeywordManager;
